<template>
  <nav :class="$style['top-bar']">
    <h3 :class="$style['top-bar__title']">
      {{ title }}
    </h3>

    <div :class="$style['top-bar-actions']">
      <slot name="actions" />
      <Button
        v-if="$slots.filter"
        responsive
        :icon="showFilters ? 'X' : 'ListFilter'"
        @click="showFilters = !showFilters">
        Filters
      </Button>
    </div>
    <div v-if="showFilters" :class="$style['top-bar-filters']">
      <slot name="filter" />
    </div>
  </nav>
</template>
<script setup lang="ts">
defineProps<{
  title?: String
}>()
const showFilters = ref(false)
</script>
<style module>
.top-bar {
  background-color: var(--background-subtle);
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: var(--spacing);
  padding: var(--spacing) var(--spacing-l);
  margin-bottom: var(--spacing-l);
  z-index: 10;
}

.top-bar__title {
  font-size: clamp(0.6rem, 2.5vw, 2rem);
}

.top-bar-actions {
  margin-left: auto;
  display: flex;
  gap: var(--spacing);
}

.top-bar-filters {
  background-color: var(--background-raised);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow-elevation-3);
  display: flex;
  flex-direction: row;
  padding: var(--spacing-l);
  gap: var(--spacing);
  position: absolute;
  right: 0;
  z-index: 20;
  bottom: 0;
  transform: translateY(100%);

  max-width: 100%;
}
</style>
